import { render } from "./DialogCompletaPagamento.vue?vue&type=template&id=4ede9f55"
import script from "./DialogCompletaPagamento.vue?vue&type=script&lang=js"
export * from "./DialogCompletaPagamento.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__